module.exports = __webpack_public_path__ + "img/news.87f249e0.png";